import type { Table } from "dexie";
import { BaseDexieRepository } from "./base-repository";
import type {
  AudioRecordingAudioBlob,
  AudioRecordingBlobRecord,
} from "@/domains/dexie-db/models/audio-recording-legacy";

export class AudioRecordingLegacyBlobsRepository extends BaseDexieRepository<AudioRecordingBlobRecord> {
  constructor(table: Table<AudioRecordingBlobRecord, number>) {
    super({ tableRef: () => table });
  }

  async append({
    recordingId,
    noteId,
    blobData,
    createdAt = Date.now(),
  }: {
    recordingId: string;
    noteId?: string;
    blobData: Blob;
    createdAt?: number;
  }): Promise<void> {
    await this.transaction("rw", async () => {
      const blobIndex = await this.table.where({ recordingId }).count();
      await this.table.add({
        recordingId,
        noteId,
        blobIndex,
        blobData,
        createdAt,
      });
    });
  }

  async listByRecordingId(recordingId: string): Promise<AudioRecordingAudioBlob[]> {
    const rows = await this.table.where({ recordingId }).toArray();
    return rows
      .sort((a, b) => a.blobIndex - b.blobIndex)
      .map(({ blobIndex, blobData }) => ({ blobIndex, blobData }));
  }

  async clearByRecordingId(recordingId: string): Promise<void> {
    await this.table.where({ recordingId }).delete();
  }

  async clearByNoteId(noteId: string): Promise<void> {
    await this.table.where({ noteId }).delete();
  }
}
